<!--sso:e卷通阅卷登录 2022/10/10 10:01:10 YuAng-->

<template>
  <div class="yj-sso">
    <p v-html="tip"></p>
    <p v-if="tryLogin" @click="logout" class="yj-sso-logout">重新登录</p>
    <p v-else-if="isSelf === false" @click="back" class="yj-sso-back">返回上一页</p>
  </div>
</template>
<script>
import { getMyRole, getHistoryYear, ssoCheck } from "@/api/login";
import { queryListGrade } from "@/api/api";
import { baseData } from "@/v2/utils/data";
export default {
  name: 'sso',
  data () {
    return {
      tip: '',
      isSelf: true,
      tryLogin: false,
      ssoUrl: process.env.VUE_APP_SSO_URL,
    }
  },
  created () {
    this.isSelf = top.location === self.location
    this.tryLogin = false
    const { message, type } = this.$route.query
    if (message) {
      this.tip = message
      this.tryLogin = this.isSelf
      return
    }
    if (type === 'logout') {
      this.logout()
      return
    }
    this.checkLogin()
  },
  methods: {
    checkLogin: function () {
      ssoCheck(this.ssoUrl).then(resp => {
        if (resp.success) {
          this.tip = ''
          const params = this.isSelf ? { type: 'sso' } : { type: 'zujuan' }
          params.loginPlatform = 'school'
          this.$store.dispatch("localLogin", params).then(async user => {
            if (user.loginName === resp.loginName) {
              await this.getConfig(user);
              this._pathToIndex(user);
            } else {
              this.clearStorage()
              this.tip = 'e卷通阅卷：抱歉，登录用户“' + user.loginName + '”不一致<br /><br />请清空浏览器缓存(Cookie 和其他站点数据)重试'
              setTimeout(() => {
                location.href = '/api/marking-login/sso/logout'
              }, 1 * 1000);
            }
          }).catch((error) => {
            if (error.code === 401) {
              this.login()
            } else {
              this.tip = 'e卷通阅卷：抱歉，' + error.message
              this.tryLogin = this.isSelf
            }
          });
        } else {
          this.login()
        }
      })
    },
    clearStorage () {
      YJ_SCHOOL_STORAGE.removeItem('token');
      YJ_SCHOOL_STORAGE.removeItem("userInfo");
      YJ_SCHOOL_STORAGE.removeItem("menus");
      YJ_SCHOOL_STORAGE.removeItem("pathArray");
      this.$store.commit('LOGOUT_SUCCES', '');
    },
    logout: function () {
      this.clearStorage()
      if (this.isSelf) {
        const url = this.ssoUrl + '/logout?service=' + encodeURIComponent(location.origin + '/sso/logout?service=' + encodeURIComponent(location.origin + '/sso-login'))
        window.open(url, '_self')
      } else {
        // 增加redirect参数，确保父页面退出登录成功
        const url = process.env.VUE_APP_EJT_URL + '/exam/single'
        top.location.href = this.ssoUrl + '/logout?service=' + encodeURIComponent(url) + '&redirect=' + encodeURIComponent(url)
      }
    },
    login: function () {
      // 清空所有cookie
      this.clearCookie()
      const oldUrl = YJ_SCHOOL_STORAGE.getItem('url_before_login')
      let jumpNext = oldUrl ? oldUrl : location.origin + '/third/zujuan'
      if (this.$route.query.fromPath) {
        jumpNext = location.origin + this.$route.query.fromPath
      } else if (this.isSelf) {
        jumpNext = location.origin + '/sso-login'
      }
      // 经过验证，还是这个位置最适合处理xep_flag参数
      const xep_flag = this.$route.query.xep_flag
      if (xep_flag) {
        if (jumpNext.indexOf('?') >= 0) {
          jumpNext += '&xep_flag=' + xep_flag
        } else {
          jumpNext += '?xep_flag=' + xep_flag
        }
      }
      const url = this.ssoUrl + '/login?service=' + encodeURIComponent(location.origin + '/sso/login?service=' + encodeURIComponent(jumpNext))
      location.href = url
    },
    clearCookie: function () {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--;) {
          document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
        }
      }
    },
    back: function () {
      window.history.back()
    },
    // 获取配置信息
    async getConfig (json) {
      await this.getHistoryYear(json);
      await this.queryListGrade(json);

      if (json.historyRole == 1) {
        await this.getHistoryAuth(json);
      }
    },

    // 获取历史学年
    async getHistoryYear (userInfo) {
      let res = await getHistoryYear({ schoolId: userInfo.schoolId });
      let yearList = [];

      for (let item of res.body) {
        yearList.unshift({
          label: `${item.startYear}-${item.endYear}`,
          value: item.startYear,
        });
      }

      yearList.unshift({
        label: "当前学年",
        value: userInfo.academicYear,
      });
      YJ_SCHOOL_STORAGE.setItem("academicYearList", JSON.stringify(yearList));
      this.$store.commit("setAcademicYearList", yearList);
    },

    // 获取学校当前学年的年级
    async queryListGrade (userInfo) {
      let params = {
        schoolId: userInfo.schoolId,
        academicYear: userInfo.academicYear,
      };

      let res = await queryListGrade(params);
      this.tryLogin = this.isSelf
      if (res.body) {
        let gradeList = res.body;
        YJ_SCHOOL_STORAGE.setItem("gradeList", JSON.stringify(gradeList));
        this.$store.commit("setGradeList", gradeList);
      } else {
        this.repeatGradeRequestTimes--;

        if (this.repeatGradeRequestTimes > 0) {
          this.queryListGrade(userInfo);
        } else {
          this.$notify.error({
            title: "警告",
            message: "年级列表获取失败",
          });
        }
      }
    },

    //获取历史学年权限
    async getHistoryAuth (userInfo) {
      let res = await getMyRole(userInfo.userId);
      this.tryLogin = true
      if (res.success) {
        YJ_SCHOOL_STORAGE.setItem("historyRole", JSON.stringify(res.body));
      } else {
        YJ_SCHOOL_STORAGE.removeItem("historyRole");
        this.$notify.error({
          title: "警告",
          message: "网络异常，请重新登录",
        });
      }
    },

    _pathToIndex (user) {
      // 1. 检查用户权限
      const hasMarkingPermission = user.productPermissionIds.includes('gdejtyj') // 是否有阅卷权限
      const savedUrl = YJ_SCHOOL_STORAGE.getItem('url_before_login') // 获取登录前保存的URL
      
      // 2. 处理登录前保存的URL,如果存在则跳转
      const handleSavedUrl = () => {
        if (savedUrl) {
          YJ_SCHOOL_STORAGE.removeItem('url_before_login') // 清除保存的URL
          this.$router.replace(savedUrl.replace(location.origin, '')) // 跳转到保存的URL
          return true
        }
        return false
      }

      // 3. 根据权限和用户类型跳转到不同页面
      // 3.1 无阅卷权限 -> 制卡页面
      if (!hasMarkingPermission) {
        handleSavedUrl() || this.$router.replace('/v2/card/index') 
        return
      }

      // 3.3 处理其他情况
      if (!handleSavedUrl()) {
        // 默认跳转组卷页面
        let jumpNext = '/third/zujuan'

        // 如果是自己的系统,根据菜单权限跳转
        if (this.isSelf) {
          const menus = baseData.getNavigators()
          // 无可用菜单或临时学校 -> 制卡页面
          // 有可用菜单 -> 第一个菜单页面
          if (menus.length === 0 || user.tmpSchool) {
            jumpNext = '/v2/card/index'
          } else {
            jumpNext = menus[0].moduleUrl
          }
        }

        this.$router.replace(jumpNext)
      }
    }
  }
}
</script>

<style scoped>
.yj-sso {
  padding: 30px;
  text-align: center;
  color: #999;
}

.yj-sso-logout,
.yj-sso-back {
  color: #2877ff;
  margin-top: 8px;
  cursor: pointer;
}

.yj-sso-back {
  display: none;
}

.yj-sso-logout:hover {
  text-decoration: underline;
}
</style>